/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ConsultaAlteracaoCadastralAliases {
  DATA_INICIO = 'data-inicio',
  DECK_0 = 'deck-0',
  FETCH_CONSULTA = 'fetch-consulta',
  FETCH_PERSON_DATA_DETAILS = 'fetch-person-data-details',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_ATRIBUTO = 'field-atributo',
  FIELD_INICIO = 'field-inicio',
  FIELD_VALOR_NEW = 'field-valor-new',
  FIELD_VALOR_OLD = 'field-valor-old',
  FORM_0 = 'form-0',
  HPMS_CUSTOM_CARD_ALTERACAO_CADASTRAL = 'hpms-custom-card-alteracao-cadastral',
  LAYOUT_PERSON_DATA_CHANGE_DETAILS = 'layout-person-data-change-details',
  MODAL_DATA_CHANGE_DETAILS = 'modal-data-change-details',
  PANEL_3 = 'panel-3',
  PANEL_ALTERACAO_CADASTRAL = 'panel-alteracao-cadastral',
  PANEL_MODAL_SILICITACAO = 'panel-modal-silicitacao',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_ATRIBUTO = 'text-atributo',
  TEXT_VALOR_NEW = 'text-valor-new',
  TEXT_VALOR_OLD = 'text-valor-old',
}
export { ConsultaAlteracaoCadastralAliases };
